
import { createRouter, createWebHashHistory } from 'vue-router';

import { useAuth } from 'src/composables/auth';


let routes = [
	//Dashboard routes


//clients routes
			{
				path: '/clients/:index?/:fieldName?/:fieldValue?',
				name: 'clientslist',
				component: () => import('./pages/clients/list.vue'), 
				props: true
			},
			
	
			{ 
				path: '/clients/view/:id', 
				name: 'clientsview', 
				component: () => import('./pages/clients/view.vue'), 
				props: true
			},
	
			{ 
				path: '/clients/add', 
				name: 'clientsadd', 
				component: () => import('./pages/clients/add.vue'), 
				props: true
			},
	
			{ 
				path: '/clients/edit/:id', 
				name: 'clientsedit', 
				component: () => import('./pages/clients/edit.vue'), 
				props: true
			},
		

//data routes
			{
				path: '/data/:index?/:fieldName?/:fieldValue?',
				name: 'datalist',
				component: () => import('./pages/data/list.vue'), 
				props: true
			},
			
	
			{ 
				path: '/data/view/:id', 
				name: 'dataview', 
				component: () => import('./pages/data/view.vue'), 
				props: true
			},
	
			{ 
				path: '/data/add', 
				name: 'dataadd', 
				component: () => import('./pages/data/add.vue'), 
				props: true
			},
	
			{ 
				path: '/data/edit/:id', 
				name: 'dataedit', 
				component: () => import('./pages/data/edit.vue'), 
				props: true
			},
		

//devices routes
			{
				path: '/devices/:index?/:fieldName?/:fieldValue?',
				name: 'deviceslist',
				component: () => import('./pages/devices/list.vue'), 
				props: true
			},
			
	
			{ 
				path: '/devices/view/:id', 
				name: 'devicesview', 
				component: () => import('./pages/devices/view.vue'), 
				props: true
			},
	
			{ 
				path: '/devices/add', 
				name: 'devicesadd', 
				component: () => import('./pages/devices/add.vue'), 
				props: true
			},
	
			{ 
				path: '/devices/edit/:id', 
				name: 'devicesedit', 
				component: () => import('./pages/devices/edit.vue'), 
				props: true
			},
		

//users routes
			{
				path: '/users/:index?/:fieldName?/:fieldValue?',
				name: 'userslist',
				component: () => import('./pages/users/list.vue'), 
				props: true
			},
			
	
			{ 
				path: '/users/view/:id', 
				name: 'usersview', 
				component: () => import('./pages/users/view.vue'), 
				props: true
			},
	
			{ 
				path: '/account/edit', 
				name: 'usersaccountedit', 
				component: () => import('./pages/account/accountedit.vue'), 
				props: true
			},
	
			{ 
				path: '/account', 
				name: 'usersaccountview', 
				component: () => import('./pages/account/accountview.vue'), 
				props: true
			},
	
			{ 
				path: '/users/add', 
				name: 'usersadd', 
				component: () => import('./pages/users/add.vue'), 
				props: true
			},
	
			{ 
				path: '/users/edit/:id', 
				name: 'usersedit', 
				component: () => import('./pages/users/edit.vue'), 
				props: true
			},
		

//users_type routes
			{
				path: '/users_type/:index?/:fieldName?/:fieldValue?',
				name: 'users_typelist',
				component: () => import('./pages/users_type/list.vue'), 
				props: true
			},
			
	
			{ 
				path: '/users_type/view/:id', 
				name: 'users_typeview', 
				component: () => import('./pages/users_type/view.vue'), 
				props: true
			},
	
			{ 
				path: '/users_type/add', 
				name: 'users_typeadd', 
				component: () => import('./pages/users_type/add.vue'), 
				props: true
			},
	
			{ 
				path: '/users_type/edit/:id', 
				name: 'users_typeedit', 
				component: () => import('./pages/users_type/edit.vue'), 
				props: true
			},
		

	
	
//Password reset routes
			{ 
				path: '/index/forgotpassword', 
				name: 'forgotpassword', 
				component: () => import('./pages/index/forgotpassword.vue'), 
				props: true
			},
			{ 
				path: '/index/resetpassword', 
				name: 'resetpassword', 
				component: () => import('./pages/index/resetpassword.vue'), 
				props: true
			},
			{ 
				path: '/index/resetpassword_completed', 
				name: 'resetpassword_completed', 
				component: () => import('./pages/index/resetpassword_completed.vue'), 
				props: true
			},
	
	
	
	{ 
		path:  '/error/forbidden', 
		name: 'forbidden', 
		component: () => import('./pages/errors/forbidden.vue'),
		props: true
	},
	{ 
		path: '/error/notfound', 
		name: 'notfound',
		component: () => import('./pages/errors/pagenotfound.vue'),
		props: true
	},
	{
		path: '/:catchAll(.*)', 
		component: () => import('./pages/errors/pagenotfound.vue')
	}
];

export default () => {
	
const auth = useAuth();

	
	const user = auth.user;
	if(user){
		routes.push({ path: '/', alias: '/home', name: 'home', component: () => import(`./pages/home/home.vue`) });
	}
	else{
		routes.push({ path: '/', alias: '/index', name: 'index', component: () => import('./pages/index/index.vue') });
	}

	const router = createRouter({
		history: createWebHashHistory(),
		routes,
		scrollBehavior(to, from, savedPostion){
			//if(savedPostion) return savedPostion;
			return { x:0, y:0 }
		}
	});
	
	router.beforeEach((to, from, next) => {
		const user = auth.user;
		let path = to.path;
		let authRequired = auth.pageRequiredAuth(path);
		
		//authenticate user
		if (authRequired && !user) {
			//user is not logged. redirect to login
			return next({ path: '/',  query: { nexturl: to.fullPath } });
		}

		if(user && to.name == "index"){
			//already logged in, show home when try to access index page
			return next({ path: "/home"});
		}

		//navigate to redirect url if available
		if(to.name == "home" && to.query.nexturl){
			return next({ path: to.query.nexturl});
		}

		//close dialog from previous page
		//store.dispatch('app/closeDialogs');

		//continue to specified route
		next();
	});

	return router;
}
